import React, { useRef, useState } from "react";

import Popover from "@mui/material/Popover";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import "./infoHover.sass";


const ExclamationHover: React.FC<ComponentProps> = ({ size, children }) => {
    const [showPopover, setShowPopover] = useState(false);
    const popoverRef = useRef(null);

    return (
        <>
            <InfoOutlinedIcon
                ref={popoverRef}
                onMouseEnter={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                style={size === "small" ? { fontSize: 16 } : {}}
            />
            <Popover
                open={showPopover}
                anchorEl={popoverRef.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                }}
                PaperProps={{
                    onMouseEnter: () => setShowPopover(true),
                    onMouseLeave: () => setShowPopover(false),
                    style: {
                        maxWidth: 250
                    }
                }}
                style={{ pointerEvents: "none" }}
                onClose={() => setShowPopover(false)}
                classes={{
                    paper: "help-icon-description"
                }}
            >
                {children}
            </Popover>
        </>
    );
};

interface ComponentProps {
    size?: "initial" | "small";
}

export default ExclamationHover;